import { render, staticRenderFns } from "./CreateKasbonApproval.vue?vue&type=template&id=171e6cca"
import script from "./CreateKasbonApproval.vue?vue&type=script&lang=js"
export * from "./CreateKasbonApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports